/** Compact reCAPTCHA disclosure for email sign-in (Firebase invisible Enterprise). */
import { RECAPTCHA_LOGO_URL, RECAPTCHA_NOTICE_LABEL } from './recaptchaNoticeCopy';

export function RecaptchaNotice() {
  return (
    <p className="login-form__recaptcha">
      <img
        className="login-form__recaptcha-icon"
        src={RECAPTCHA_LOGO_URL}
        alt=""
        width={20}
        height={20}
        decoding="async"
      />
      <span>{RECAPTCHA_NOTICE_LABEL}</span>
    </p>
  );
}
